/*eslint no-unused-vars:0 no-trailing-spaces:0 */
/*global localStorage localforage alert */
let _ = require("ES/lib/lodash");
let dd = require("ES/lib/dd");
let radio = require("ES/lib/radio");
let esUtils = require("ES/utils/esUtils");
let FormUtils = require("../../../utils/FormUtils");
let RadioMixin = require("ES/lib/react-pubsub-via-radio.js/RadioMixin");
let FullLayout = require("ES/widgets/FullLayout");
let ErrorAlert = require("ES/widgets/ErrorAlert");
let LoadingWrap = require("ES/widgets/LoadingWrap");
let VerticalScroll = require("ES/widgets/VerticalScroll");
let AuthedUserSession = require("../../../utils/AuthedUserSession");
let RadioServiceMixin = require("ES/lib/react-pubsub-via-radio.js/RadioServiceMixin");
let Constants = require("../../../utils/Constants.js");

//NOTE the keys here refer to view_mode
let calendar_area_views = {
  year: {
    cmpt: require("./YearCalendar"),
    name: "Year",
  },
  month: {
    cmpt: require("./MonthCalendar"),
    name: "Month",
  },
  Dashboard: {
    cmpt: require("./Dashboard"),
    name: "Dashboard",
  },
};

let SearchForm = require("./SearchForm");
let EventSearchAside;
//TreeSearch or EventSearchAside???
if (AuthedUserSession.is_st_family) {
  calendar_area_views.TreeSearch = {
    cmpt: require("./TreeSearch"),
    name: "Search",
  };
} else {
  EventSearchAside = require("./EventSearchAside");
}

let filterCalendarToDetailIDs = function (calendar, detail_ids) {
  let new_calendar = {};
  _.each(calendar, function (months, year) {
    _.each(months, function (days, month) {
      _.each(days, function (day, date) {
        let matching_ids = _.intersection(detail_ids, day.detail_ids);
        if (matching_ids.length > 0) {
          if (!_.has(new_calendar, year)) {
            new_calendar[year] = {};
          }
          if (!_.has(new_calendar[year], month)) {
            new_calendar[year][month] = {};
          }
          let day_clone = _.cloneDeep(day); //don't mess with the Calendars cache
          day_clone.detail_ids = matching_ids;
          new_calendar[year][month][date] = day_clone;
        }
      });
    });
  });
  return new_calendar;
};

/**
 * Remove Calendar data not belonging to the active company ids.
 * Filter to a specific speaker should be done _before_ this.
 *
 * @param Calendars
 * @param include_other_companies
 * @param empire_mode
 * @returns {{}}
 */
let filterCalendarsToCompanies = function (
  Calendars,
  include_other_companies = false,
  empire_mode = false
) {
  //REMOVE detail rows that are not non [held,conf] belonging to other companies
  Calendars = _.mapValues(Calendars, function (Calendar, year) {
    let valid_detail_ids = esUtils.cleanup_ids(
      _.map(
        _.filter(
          _.map(Calendar.details, function (detail, id) {
            return { id: id, cmpid: detail.cmpid, sta: detail.sta };
          }),
          function (pair) {
            //include events for the active company
            if (
              _.includes(
                _.get(AuthedUserSession, ["activeCompanyIds"]),
                _.get(pair, ["cmpid"])
              )
            ) {
              //in empire_mode, we want only CONF, HELD
              if (empire_mode) {
                return _.includes(["confirmed", "held"], pair.sta);
              }
              return true;
            }

            //it didn't belong to the active company, and we're not including other companies or in empire_mode
            if (!include_other_companies && !empire_mode) {
              return false;
            }

            //for other company events, we only want CONF, HELD
            return _.includes(["confirmed", "held"], pair.sta);
          }
        ),
        "id"
      )
    );

    return {
      calendar: filterCalendarToDetailIDs(Calendar.calendar, valid_detail_ids),
      details: _.pick(Calendar.details, valid_detail_ids),
    };
  });

  //filtering the data is all we have to do here. The display logic in MiniCalendar.js will color things for us and figure out new day status.

  // Calendars = _.mapValues(Calendars, function (Calendar, year) {
  //   let calendar = _.mapValues(Calendar.calendar, function (months) {
  //     return _.mapValues(months, function(days) {
  //       return _.mapValues(days, function(day) {
  //         let newday = _.cloneDeep(day);
  //         let new_decorators = day.decorators;
  //         let new_eventstatus = day.eventstatus;
  //
  //         //figure out if any of the day's events belong to an "other company"
  //         let has_othercompany = false;
  //         _.each(day.detail_ids, function(detail_id) {
  //           has_othercompany = has_othercompany ||  (!_.includes(AuthedUserSession.companyIdsICanRead, _.get(Calendar, ["details", detail_id, "cmpid"])));
  //         });
  //
  //         newday.decorators = new_decorators;
  //         newday.eventstatus = new_eventstatus;
  //         return newday;
  //       });
  //     });
  //   });
  //
  //   return {
  //     calendar: calendar,
  //     details: Calendar.details
  //   };
  // });
  return Calendars;
};

let filterCalendarsToSID = function (Calendars, sid) {
  return _.mapValues(Calendars, function (Calendar, year) {
    let valid_detail_ids = esUtils.cleanup_ids(
      _.map(
        _.filter(
          _.map(Calendar.details, function (detail, id) {
            return { id: id, sids: esUtils.cleanup_ids(detail.sids) };
          }),
          function (pair) {
            return _.includes(pair.sids, sid);
          }
        ),
        "id"
      )
    );

    return {
      calendar: filterCalendarToDetailIDs(Calendar.calendar, valid_detail_ids),
      details: _.pick(Calendar.details, valid_detail_ids), //altho we could just pass them all back, they are not used b/c filterCalendarToDetailIDs filtered out references to them
    };
  });
};

let filterCalendarDecoratorsToSID = function (Calendars, sid) {
  return _.mapValues(Calendars, function (Calendar, year) {
    let new_calendar = {};
    _.each(Calendar.calendar, function (months, year) {
      _.each(months, function (days, month) {
        _.each(days, function (day, date) {
          if (!_.has(new_calendar, year)) {
            new_calendar[year] = {};
          }
          if (!_.has(new_calendar[year], month)) {
            new_calendar[year][month] = {};
          }
          let day_clone = _.cloneDeep(day); //don't mess with the Calendars cache
          if (sid > 0) {
            let new_decorators = [];
            _.each(day_clone.decorators, function (sids, type) {
              if (_.indexOf(sids, sid.toString()) > -1) {
                new_decorators.push(type);
              }
            });
            day_clone.decorators = _.uniq(new_decorators);
          } else {
            day_clone.decorators = _.keys(day_clone.decorators);
          }
          new_calendar[year][month][date] = day_clone;
        });
      });
    });
    return {
      calendar: new_calendar,
      details: Calendar.details,
    };
  });
};

let MonthYearToggle = dd.createClass({
  __setViewOnClick(view_mode) {
    return esUtils.wrapPreventDefault(function () {
      radio("Show_Calendar").broadcast(view_mode);
    });
  },
  __openSearch: esUtils.wrapPreventDefault(function () {
    radio("EventSearchAside_open").broadcast();
  }),
  render() {
    let { view_mode } = this.props;
    return dd.ul(
      { className: "nav nav-pills small", style: { display: "inline-block" } },
      _.map(
        calendar_area_views,
        function ({ name }, mode) {
          return dd.li(
            { key: mode, className: mode === view_mode ? "active" : null },
            dd.a({ href: "#", onClick: this.__setViewOnClick(mode) }, name)
          );
        },
        this
      ),
      this.props.show_search_btn
        ? dd.li(
            null,
            //dd.a({href: "#", onClick: this.__openSearch}, dd.i({className: "fa fa-search"}))
            dd.button(
              {
                type: "submit",
                className: "btn btn-default",
                onClick: this.__openSearch,
              },
              dd.i({ className: "fa fa-search" })
            )
          )
        : null
    );
  },
});

let excludeOtherCompaniesForm = dd.createClass({
  render() {
    let { include_other_companies, waiting_for_displaylists, empire_mode } =
      this.props;
    if (
      AuthedUserSession.is_st_family &&
      !waiting_for_displaylists &&
      _.includes(["year", "month"], this.props.view_mode)
    ) {
      return dd.div(
        { style: { display: "block", marginLeft: "1rem", fontSize: "100%" } },
        Constants.ST_USERTYPE_SUPER_ADMIN !==
          _.get(AuthedUserSession, "st_usertype")
          ? null
          : dd.div(
              {
                className: "pull-left",
                style: { marginRight: "1rem" },
              },
              dd.input({
                id: "empire_mode_checkbox",
                type: "checkbox",
                checked: empire_mode,
                onChange: this.props.toggleEmpireMode,
                style: {},
              }),
              dd.label(
                {
                  htmlFor: "empire_mode_checkbox",
                  style: { paddingLeft: "5px" },
                },
                " empire"
              )
            ),
        _.get(this.props, "empire_mode", false)
          ? null
          : dd.div(
              {},
              dd.input({
                id: "show_other_companies_checkbox",
                type: "checkbox",
                checked: include_other_companies,
                onChange: this.props.toggleIncludeOtherCompanies,
              }),
              dd.label(
                {
                  htmlFor: "show_other_companies_checkbox",
                  style: { paddingLeft: "5px" },
                },
                " other companies"
              )
            )
      );
    } else {
      return null;
    }
  },
});

let SelectSpeakerForm = dd.createClass({
  __onChange(e) {
    let value = _.parseInt(e.target.value);
    this.props.setSIDFilter(value > 0 ? value : 0);
  },
  render() {
    let { Displaylists, filter_to_sid } = this.props;
    let my_speakers = _.get(this.props, "empire_mode", false)
      ? FormUtils.getSpeakerNamesBySidForEveryCompany(Displaylists)
      : FormUtils.getSpeakerNamesBySid(Displaylists, false);
    if (_.size(my_speakers) === 0) {
      return dd.span();
    } else if (_.size(my_speakers) === 1) {
      return dd.b({ style: { lineHeight: "30px" } }, _.first(my_speakers));
    }
    my_speakers = _.sortBy(_.pairs(my_speakers), function (o) {
      return o[1];
    });
    return dd.select(
      {
        className: "form-control",
        value: filter_to_sid,
        onChange: this.__onChange,
        style: { width: "14rem" },
      },
      dd.option({ value: 0 }, "--- all speakers --"),
      _.map(my_speakers, function (a) {
        return dd.option({ key: a[0], value: a[0] }, a[1]);
      })
    );
  },
});

let CalendarHeader = dd.createClass({
  render() {
    let {
      Displaylists,
      filter_to_sid,
      view_mode,
      setSIDFilter,
      toggleIncludeOtherCompanies,
      toggleEmpireMode,
      include_other_companies,
      empire_mode,
      waiting_for_displaylists,
    } = this.props;
    if (calendar_area_views.TreeSearch) {
      return dd.div(
        { className: "CalendarHeader" },
        dd.div(
          { className: "row" },
          dd.div(
            { className: "col-xs-5" },
            AuthedUserSession.is_st_family && view_mode === "TreeSearch"
              ? null
              : SelectSpeakerForm({
                  Displaylists,
                  filter_to_sid,
                  setSIDFilter,
                  empire_mode,
                }),
            AuthedUserSession.is_st_family && view_mode === "TreeSearch"
              ? null
              : excludeOtherCompaniesForm({
                  Displaylists,
                  view_mode,
                  toggleIncludeOtherCompanies,
                  include_other_companies,
                  empire_mode,
                  toggleEmpireMode,
                  waiting_for_displaylists,
                })
          ),
          dd.div(
            { className: "col-xs-7 text-right" },
            MonthYearToggle({ view_mode })
          )
        )
      );
    }
    return dd.div(
      { className: "CalendarHeader" },
      dd.div(
        { className: "larger-screen" },
        FullLayout({ horizontal: true }, [
          {
            width: 300,
            body: dd.div(
              { style: { padding: "10px 0 10px 10px" } },
              SelectSpeakerForm({
                Displaylists,
                filter_to_sid,
                setSIDFilter,
                empire_mode,
              }),
              excludeOtherCompaniesForm({
                Displaylists,
                view_mode,
                toggleIncludeOtherCompanies,
                include_other_companies,
                toggleEmpireMode,
                empire_mode,
              })
            ),
          },
          {
            body: dd.div(
              { className: "text-center", style: { padding: "10px 0 0 0" } },
              MonthYearToggle({ view_mode })
            ),
          },
          {
            width: AuthedUserSession.is_st_family ? 10 : 200,
            body: dd.div(
              { style: { padding: "10px 10px 10px 0" } },
              SearchForm({
                mini_form: true,
                default_filter_to_sid: filter_to_sid,
              })
            ),
          },
        ])
      ),
      dd.div(
        { className: "smaller-screen row", style: { marginTop: 7 } },
        dd.div(
          { className: "col-xs-6" },
          SelectSpeakerForm({
            Displaylists,
            filter_to_sid,
            setSIDFilter,
            empire_mode,
          }),
          excludeOtherCompaniesForm({
            Displaylists,
            toggleIncludeOtherCompanies,
            include_other_companies,
            toggleEmpireMode,
            empire_mode,
          })
        ),
        dd.div(
          { className: "col-xs-6" },
          MonthYearToggle({ view_mode, show_search_btn: true })
        )
      )
    );
  },
});

let Main = dd.createClass({
  mixins: [RadioServiceMixin],
  RadioService_setup() {
    return {
      Dashboard_get: {
        key() {
          return 1;
        },
      },
      Calendar_get: {
        key() {
          return this.props.year;
        },
      },
    };
  },
  componentDidMount() {
    radio("Calendar_get").broadcast({
      year: _.get(this.props, "year"),
      include_other_companies: _.get(
        this.props,
        "include_other_companies",
        false
      ),
      empire_mode: _.get(this.props, "empire_mode", false),
    });
    radio("Dashboard_get").broadcast();
  },
  componentWillReceiveProps(next_props) {
    if (this.props.year !== next_props.year) {
      radio("Calendar_get").broadcast({ year: next_props.year });
    }
  },
  __onScroll() {
    radio("MiniCalendar_close_all_popovers").broadcast();
  },
  __clearCalendarData() {
    this.setState({
      Calendar_get: { data: {}, waiting: true },
    });
  },
  render() {
    let {
      year,
      month,
      view_mode,
      Displaylists,
      filter_to_sid,
      setSIDFilter,
      toggleIncludeOtherCompanies,
      include_other_companies,
      toggleEmpireMode,
      empire_mode,
      waiting_for_displaylists,
    } = this.props;
    let { Dashboard_get, Calendar_get } = this.state;

    let Calendars = _.get(Calendar_get, "data", {});
    if (filter_to_sid > 0) {
      Calendars = filterCalendarsToSID(Calendars, filter_to_sid);
    }
    if (AuthedUserSession.is_st_family) {
      //TEAM ADMIN
      Calendars = filterCalendarsToCompanies(
        Calendars,
        include_other_companies,
        empire_mode
      );
    }
    Calendars = filterCalendarDecoratorsToSID(Calendars, filter_to_sid);

    let is_loading = false;
    // Load all the views and hide the inactive ones.  this way we don't mount/unmount the views and lose our data
    let body = dd.div(
      {},
      _.map(calendar_area_views, function (view, key) {
        return dd.div(
          {
            key: key,
            id: key,
            style: { display: key === view_mode ? "block" : "none" },
          },
          view.cmpt({
            Displaylists,
            filter_to_sid,
            year,
            month,
            Calendars,
            Dashboarddata: Dashboard_get.data,
            include_other_companies,
            empire_mode,
          })
        );
      })
    );
    if (view_mode === "year" || view_mode === "month") {
      is_loading = false;
    } else if (view_mode === "Dashboard") {
      is_loading = !!Dashboard_get.waiting;
    }
    return dd.div(
      { id: "calendar_area", className: "relative" },
      FullLayout({ vertical: true }, [
        {
          height: 75,
          body: CalendarHeader({
            Displaylists,
            view_mode,
            filter_to_sid,
            setSIDFilter,
            include_other_companies,
            empire_mode,
            toggleIncludeOtherCompanies,
            toggleEmpireMode,
            waiting_for_displaylists,
          }),
        },
        {
          body: LoadingWrap(
            { is_loading: _.isEmpty(Displaylists) || is_loading, glass: true },
            VerticalScroll(
              { onScroll: this.__onScroll },
              ErrorAlert({ message: Calendar_get.error }),
              ErrorAlert({ message: Dashboard_get.error }),
              body,
              dd.div({ className: "clearfix" })
            )
          ),
        },
      ]),
      EventSearchAside ? EventSearchAside({ Displaylists }) : null
    );
  },
});

module.exports = dd.createClass({
  mixins: [RadioMixin],
  getInitialState() {
    let today = new Date();

    let empire_mode_initially = false;
    let view_mode = "Dashboard";

    if (
      AuthedUserSession.is_st_family &&
      Constants.ST_USERTYPE_SUPER_ADMIN === AuthedUserSession.st_usertype
    ) {
      if (window.location.hash.includes("empire_mode")) {
        empire_mode_initially = true;
        view_mode = "year";
      }
    }

    return {
      year: today.getFullYear(),
      month: today.getMonth() + 1,
      view_mode: view_mode,
      filter_to_sid: AuthedUserSession.getLastSelectedSID(),
      include_other_companies: false,
      empire_mode: empire_mode_initially,
      waiting_for_displaylists: true,
    };
  },
  Radio_setup() {
    return {
      Show_Calendar(type_shown, d) {
        if (!_.isEmpty(type_shown)) {
          this.setState({ view_mode: type_shown });
        }
        if (_.isDate(d)) {
          this.setState({ month: d.getMonth() + 1, year: d.getFullYear() });
        }
      },
      Calendar_setSID(sid) {
        if (sid > 0) {
          this.__setSIDFilter(sid);
        }
      },
      Displaylists_get_succeeded(key, Displaylists) {
        let sids = esUtils.cleanup_ids(
          _.map(Displaylists && Displaylists.perspeaker, "sid")
        );
        if (_.size(sids) === 1) {
          this.__setSIDFilter(_.first(sids));
        }
        let preferences = _.get(Displaylists, "user.myevents_preferences", {});
        this.setState({
          include_other_companies: _.get(
            preferences,
            "show_other_companies_by_default",
            false
          ),
          waiting_for_displaylists: false,
        });
        // if (_.get(preferences, "show_other_companies_by_default", false)) {
        //   this.__toggleIncludeOtherCompanies();
        // }
      },
      EventSearchAside_search(query) {
        if (
          calendar_area_views.TreeSearch &&
          "TreeSearch" !== this.state.view_mode
        ) {
          this.setState({ view_mode: "TreeSearch" }, function () {
            //re-broadcast once the view is mounted
            radio("EventSearchAside_search").broadcast(query);
          });
        }
      },
      EventSearchAside_open() {
        if (
          calendar_area_views.TreeSearch &&
          "TreeSearch" !== this.state.view_mode
        ) {
          this.setState({ view_mode: "TreeSearch" });
        }
      },
    };
  },
  componentDidMount() {
    radio("Displaylists_get").broadcast();
  },
  __setSIDFilter(sid) {
    sid = _.isNumber(sid) && !_.isNaN(sid) && sid > 0 ? sid : 0;
    this.setState({ filter_to_sid: sid });
    AuthedUserSession.setLastSelectedSID(sid);
  },
  __toggleIncludeOtherCompanies() {
    this.setState({
      include_other_companies: !_.get(
        this.state,
        "include_other_companies",
        false
      ),
      empire_mode: false,
    });
    radio("Show_Calendar").broadcast();
  },
  __toggleEmpireMode() {
    this.setState({
      empire_mode: !_.get(this.state, "empire_mode", false),
      include_other_companies: false,
    });
    radio("Show_Calendar").broadcast();
  },

  render() {
    let { Displaylists } = this.props;
    let {
      year,
      month,
      view_mode,
      filter_to_sid,
      include_other_companies,
      empire_mode,
      waiting_for_displaylists,
    } = this.state;
    return Main({
      year,
      month,
      view_mode,
      Displaylists,
      filter_to_sid,
      include_other_companies,
      empire_mode,
      waiting_for_displaylists,
      setSIDFilter: this.__setSIDFilter,
      toggleIncludeOtherCompanies: this.__toggleIncludeOtherCompanies,
      toggleEmpireMode: this.__toggleEmpireMode,
    });
  },
});



// WEBPACK FOOTER //
// ./src/components/main_view/calendar_area/index.js